import React from 'react'
import './style.css'
const index = () => {
    let frameStyle={
        width: '100%',
        marginBottom: '3rem',
        border: '0',
        transform: 'scale(1)',
        overflow: 'hidden'
    }
  return (
          <div className="component-desc">
            <h2 className="heading">Card</h2>
            <div className="description">Card is a pattern which groups information about a particular product or topic. It also contains some action for user to interact.</div>
            <div className="divider"></div>
                <h4 className="heading">Text Card Primary</h4>
                <div style={{alignSelf:'center'}}>
                <div style={{width: '50%', padding: '4rem'}}>
                    <div class="card card--primary">
                        <header class="card__header">Card Title</header>
                        <div class="card__body">
                            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eum,
                            assumenda?
                        </div>
                        </div>
                    </div>
                </div>
                <div className="carbon-container">
                    <iframe
                        src="https://carbon.now.sh/embed?bg=rgba%28255%2C255%2C255%2C0%29&t=blackboard&wt=none&l=javascript&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14.5px&lh=133%25&si=false&es=2x&wm=false&code=%253Cdiv%2520className%253D%2522card%2522%253E%250A%2520%2520%2509%253Cimg%2520className%253D%2522card-img%2522%2520src%253D%2522%2522%2520alt%253D%2522%2522%253E%250A%2509%253Cdiv%2520className%253D%2522card-text%2522%253E%250A%2520%2520%2520%2520%2509%253Ch4%2520className%253D%2522card-title%2522%253EHERE%2526NOW%253C%252Fh4%253E%250A%2520%2520%2520%2520%2509%253Cp%2520className%253D%2522card-description%2522%253EMen%2520Printed%2520Round%2520Neck%2520T-shirt%253C%252Fp%253E%250A%2520%2520%2520%2520%2509%253Cp%2520className%253D%2522card-price%2522%253ERs.%2520500%253C%252Fp%253E%250A%2520%2520%2520%2520%253C%252Fdiv%253E%250A%253C%252Fdiv%253E"
                        style={frameStyle}
                        sandbox="allow-scripts allow-same-origin">
                    </iframe>
                </div>

                <div className="divider"></div>

                <h4 className="heading">Text Card Secondary</h4>
                <div style={{alignSelf:'center'}}>
                <div style={{width: '50%', padding: '4rem'}}>
                    <div class="card card--secondary">
                        <header class="card__header">Card Title</header>
                        <div class="card__body">
                            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eum,
                            assumenda?
                        </div>
                        </div>
                    </div>
                </div>
                <div className="carbon-container">
                    <iframe
                        src="https://carbon.now.sh/embed?bg=rgba%28255%2C255%2C255%2C0%29&t=blackboard&wt=none&l=javascript&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14.5px&lh=133%25&si=false&es=2x&wm=false&code=%253Cdiv%2520className%253D%2522card%2522%253E%250A%2520%2520%2509%253Cimg%2520className%253D%2522card-img%2522%2520src%253D%2522%2522%2520alt%253D%2522%2522%253E%250A%2509%253Cdiv%2520className%253D%2522card-text%2522%253E%250A%2520%2520%2520%2520%2509%253Ch4%2520className%253D%2522card-title%2522%253EHERE%2526NOW%253C%252Fh4%253E%250A%2520%2520%2520%2520%2509%253Cp%2520className%253D%2522card-description%2522%253EMen%2520Printed%2520Round%2520Neck%2520T-shirt%253C%252Fp%253E%250A%2520%2520%2520%2520%2509%253Cp%2520className%253D%2522card-price%2522%253ERs.%2520500%253C%252Fp%253E%250A%2520%2520%2520%2520%253C%252Fdiv%253E%250A%253C%252Fdiv%253E"
                        style={frameStyle}
                        sandbox="allow-scripts allow-same-origin">
                    </iframe>
                </div>  
        </div>
  )
}

export default index